import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { CouponListTemplate } from 'components/Templates'

const CouponList: FC = () => {
  return (
    <Layout headline={'クーポン'} iconPath={'/icon/white/coupon.svg'} title={'クーポン一覧'}>
      <CouponListTemplate />
    </Layout>
  )
}

export default CouponList
